import type { ReduxModuleDefinition } from '@exodus/redux-dependency-injection';

import {
  INSTALL_CALLOUT_VISIBLE_EVENT,
  INSTALL_MODAL_VISIBLE_EVENT,
} from '@/background/features/pwa/plugin';
import type { State } from './initial-state.js';
import initialState from './initial-state.js';
import selectorDefinitions from './selectors/index.js';

const pwaReduxDefinition = {
  id: 'pwa',
  type: 'redux-module',
  initialState,
  eventReducers: {
    [INSTALL_MODAL_VISIBLE_EVENT]: (state: State, payload: boolean): State => ({
      ...state,
      data: {
        ...state.data,
        installModalVisible: payload,
      },
    }),
    [INSTALL_CALLOUT_VISIBLE_EVENT]: (
      state: State,
      payload: boolean,
    ): State => ({
      ...state,
      data: {
        ...state.data,
        installCalloutVisible: payload,
      },
    }),
  },
  selectorDefinitions,
} as const satisfies ReduxModuleDefinition;

export default pwaReduxDefinition;
